module.exports = __webpack_public_path__ + "static/media/resetpassword.30ab8dc7.png";